import { UseMutationResult, useMutation } from "react-query";
import axios, { AxiosError } from "axios";
import { log } from "common/Logger";
import { useErrorLogger } from "common/LoggerHooks";
import { FileUploadResponse, FileUploadRequest } from "domain/Types";

const uploadApi = axios.create({
  baseURL: process.env.REACT_APP_FILE_UPLOAD_URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

export const useUploadFile = (): UseMutationResult<FileUploadResponse[], AxiosError, FileUploadRequest> => {
  const { logAxiosError } = useErrorLogger();

  const UploadFile = async (fileUploadRequest: FileUploadRequest): Promise<FileUploadResponse[]> => {
    log.trace({ obj: fileUploadRequest }, "Uploading file to server");
    const formData = new FormData();
    formData.append("sessionId", fileUploadRequest.sessionId);
    fileUploadRequest.files.map((file) => {
      formData.append(`files`, file);
    });
    const response = await uploadApi.post<FileUploadResponse[]>("", formData);
    log.trace({ obj: response }, "result from upload file");
    return response.data;
  };

  return useMutation<FileUploadResponse[], AxiosError, FileUploadRequest>(UploadFile, {
    onSuccess: () => {
      log.debug("successfully uploaded new file");
    },
    onError: (err) => logAxiosError("Error uploading File", "Fehler beim Speichern der Datei", err),
  });
};
